import { windowScrollToPolyfill } from 'seamless-scroll-polyfill';

export default function scrollIntoView(elementToScrollTo, elementToOffset, scrollBehavior = 'smooth', offsetHeader = false) {
    // requires window and an element to do anything
    if (typeof window === 'undefined' || typeof elementToScrollTo === 'undefined') {
        return;
    }

    windowScrollToPolyfill();

    // if the element is a ref, it'll have .current, if it's a DOM element, it won't
    const targetElement = elementToScrollTo.current ? elementToScrollTo.current : elementToScrollTo;

    let headerOffset = 0;
    const offsetHeight = calculateOffset(elementToOffset);
    const elementTop = parseInt(targetElement.offsetTop, 10);

    if (offsetHeader) {
        const headerElement = document.getElementById('header');
        headerOffset = headerElement?.offsetHeight || 0;
    }

    const scrollOffset = elementTop + headerOffset - offsetHeight;

    window.requestAnimationFrame(() => {
        if ('scrollTo' in window) {
            window.scrollTo({ top: scrollOffset, left: 0, behavior: scrollBehavior });
        } else {
            // fallback for browsers which don't support scrollTo
            document.documentElement.scrollTop = scrollOffset;
        }
    });
}

export function calculateOffset(elementToOffset) {
    if (typeof elementToOffset !== 'undefined') {
        const offsetElement = elementToOffset.current ? elementToOffset.current : elementToOffset;
        return parseInt(offsetElement.offsetHeight, 10);
    }
    return 0;
}
